import React, { useEffect, useRef } from 'react'
import * as Styles from './embeddedContentGrid.module.scss'

enum EmbeddedContentType {
  webpage,
  pdf,
  video,
  flipsnack,
}

export type EmbeddedContentGridContent = {
  items: any[]
}

type MediaItem = {
  title: string
  link_to_embed: any
}

type Props = {
  mediaItem: MediaItem
}

const EmbeddedContent = ({ mediaItem }: Props) => {
  const { title } = mediaItem
  const { url } = mediaItem.link_to_embed

  if (!url) return null

  let wrapperClass = Styles.contentWrapper
  let embededType = EmbeddedContentType.webpage

  if (url.endsWith('.pdf')) {
    embededType = EmbeddedContentType.pdf
  } else if (url.indexOf('flipsnack') > -1) {
    wrapperClass += ` ${Styles.flipsnack}`
    embededType = EmbeddedContentType.flipsnack
  } else if (
    url.indexOf('youtube.com/embed/') > -1 ||
    url.indexOf('youtu.be') > -1
  ) {
    wrapperClass += ` ${Styles.video}`
    embededType = EmbeddedContentType.video
  }

  // iframe management
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const iframe = iframeRef.current

    const handleIframeMessage = (e: MessageEvent) => {
      if (
        e.source === iframe?.contentWindow &&
        e.data.type === 'formHeightChanged'
      ) {
        const newHeight = e.data.height
        iframe.style.height = `${newHeight}px`
      }
    }

    window.addEventListener('message', handleIframeMessage)

    return () => {
      window.removeEventListener('message', handleIframeMessage)
    }
  }, [])

  return (
    <div className={Styles.embeddedContent}>
      <div className={wrapperClass}>
        {embededType === EmbeddedContentType.webpage && (
          <iframe ref={iframeRef} title={title} src={url} />
        )}
        {embededType === EmbeddedContentType.pdf && (
          <iframe
            scrolling="no"
            title={title}
            src={`https://docs.google.com/viewerng/viewer?url=${url}&embedded=true#toolbar=0&view=FitH`}
          />
        )}
        {embededType === EmbeddedContentType.flipsnack && (
          <iframe
            scrolling="no"
            title={title}
            src={`${url}#toolbar=0&view=FitH`}
          />
        )}
        {embededType === EmbeddedContentType.video && (
          <iframe
            scrolling="no"
            title={title}
            src={`${url}#toolbar=0&view=FitH`}
            data-src={`${url}#toolbar=0&view=FitH`}
            className="optanon-category-0005"
          />
        )}
      </div>
    </div>
  )
}

const EmbeddedContentGrid = (media: any) => (
  <section className={Styles.embeddedContentGrid}>
    {media?.media?.items.map((mediaItem: any) => (
      <EmbeddedContent mediaItem={mediaItem} />
    ))}
  </section>
)

export default EmbeddedContentGrid
